import { User, UserBadges } from "stoat.js";

import badgeJoke1 from "../../../../../public/assets/badges/amog.svg";
import badgeJoke2 from "../../../../../public/assets/badges/amorbus.svg";
import badgeDeveloper from "../../../../../public/assets/badges/developer.svg";
import badgeEarlyAdopter from "../../../../../public/assets/badges/early_adopter.svg";
import badgeFounder from "../../../../../public/assets/badges/founder.svg";
import badgeModeration from "../../../../../public/assets/badges/moderation.svg";
import badgeOfficial from "../../../../../public/assets/badges/official_badge.svg";
import badgePaw from "../../../../../public/assets/badges/paw.svg";
import badgeRaccoon from "../../../../../public/assets/badges/raccoon.svg";
import badgeSupporter from "../../../../../public/assets/badges/supporter.svg";
import badgeTier1 from "../../../../../public/assets/badges/tier1_badge.svg";
import badgeTier2 from "../../../../../public/assets/badges/tier2_badge.svg";
import badgeTier3 from "../../../../../public/assets/badges/tier3_badge.svg";
import badgeTier4 from "../../../../../public/assets/badges/tier4_badge.svg";
import badgeTranslator from "../../../../../public/assets/badges/translator.svg";
import badgeVerified from "../../../../../public/assets/badges/verified_badge.svg";

export type UserBadgeItem =
  | {
      kind: "image";
      id: string;
      src: string;
      tooltip: string;
    }
  | {
      kind: "shield";
      id: string;
      tooltip: string;
    };

type BadgeText = {
  earlyAdopter: string;
  platformModerator: string;
  responsibleDisclosure: string;
  irrelevantJoke1: string;
  irrelevantJoke2: string;
};

const defaultText: BadgeText = {
  earlyAdopter: "One of the first 1000 users!",
  platformModerator: "Platform Moderator",
  responsibleDisclosure: "Responsibly disclosed security issues",
  irrelevantJoke1: "irrelevant joke badge 1",
  irrelevantJoke2: "irrelevant joke badge 2",
};

export const LEGACY_USER_BADGE_MASK =
  UserBadges.Founder |
  UserBadges.Developer |
  UserBadges.Supporter |
  UserBadges.Translator |
  UserBadges.EarlyAdopter |
  UserBadges.PlatformModeration |
  UserBadges.ResponsibleDisclosure |
  UserBadges.ReservedRelevantJokeBadge1 |
  UserBadges.ReservedRelevantJokeBadge2 |
  UserBadges.Paw;

export function getUserBadgeItems(
  user: User,
  textOverrides?: Partial<BadgeText>,
): UserBadgeItem[] {
  const text = { ...defaultText, ...textOverrides };
  const badges: UserBadgeItem[] = [];

  if (user.badges & UserBadges.Official) {
    badges.push({
      kind: "image",
      id: "official",
      src: badgeOfficial,
      tooltip: "Official",
    });
  } else if (user.badges & UserBadges.Verified) {
    badges.push({
      kind: "image",
      id: "verified",
      src: badgeVerified,
      tooltip: "Verified",
    });
  }

  if (user.showTierBadge !== false) {
    switch (user.tier) {
      case "tier1":
        badges.push({
          kind: "image",
          id: "tier1",
          src: badgeTier1,
          tooltip: "Tier 1",
        });
        break;
      case "tier2":
        badges.push({
          kind: "image",
          id: "tier2",
          src: badgeTier2,
          tooltip: "Tier 2",
        });
        break;
      case "tier3":
        badges.push({
          kind: "image",
          id: "tier3",
          src: badgeTier3,
          tooltip: "Tier 3",
        });
        break;
      case "tier4":
        badges.push({
          kind: "image",
          id: "tier4",
          src: badgeTier4,
          tooltip: "Tier 4",
        });
        break;
    }
  }

  if (user.badges & UserBadges.Founder) {
    badges.push({
      kind: "image",
      id: "founder",
      src: badgeFounder,
      tooltip: "BoopBoop Founder",
    });
  }
  if (user.badges & UserBadges.Developer) {
    badges.push({
      kind: "image",
      id: "developer",
      src: badgeDeveloper,
      tooltip: "BoopBoop Developer",
    });
  }
  if (user.badges & UserBadges.Supporter) {
    badges.push({
      kind: "image",
      id: "supporter",
      src: badgeSupporter,
      tooltip: "Donated to BoopBoop",
    });
  }
  if (user.badges & UserBadges.Translator) {
    badges.push({
      kind: "image",
      id: "translator",
      src: badgeTranslator,
      tooltip: "Helped translate BoopBoop",
    });
  }
  if (user.badges & UserBadges.EarlyAdopter) {
    badges.push({
      kind: "image",
      id: "early-adopter",
      src: badgeEarlyAdopter,
      tooltip: text.earlyAdopter,
    });
  }
  if (user.badges & UserBadges.PlatformModeration) {
    badges.push({
      kind: "image",
      id: "platform-moderation",
      src: badgeModeration,
      tooltip: text.platformModerator,
    });
  }
  if (user.badges & UserBadges.ResponsibleDisclosure) {
    badges.push({
      kind: "shield",
      id: "responsible-disclosure",
      tooltip: text.responsibleDisclosure,
    });
  }
  if (user.badges & UserBadges.ReservedRelevantJokeBadge2) {
    badges.push({
      kind: "image",
      id: "joke-1",
      src: badgeJoke1,
      tooltip: text.irrelevantJoke1,
    });
  }
  if (user.badges & UserBadges.ReservedRelevantJokeBadge1) {
    badges.push({
      kind: "image",
      id: "joke-2",
      src: badgeJoke2,
      tooltip: text.irrelevantJoke2,
    });
  }
  if (user.badges & UserBadges.Paw) {
    badges.push({
      kind: "image",
      id: "paw",
      src: badgePaw,
      tooltip: "🦊",
    });
  }
  if (user.id === "01EX2NCWQ0CHS3QJF0FEQS1GR4") {
    badges.push({
      kind: "image",
      id: "raccoon",
      src: badgeRaccoon,
      tooltip: "🦝",
    });
  }

  return badges;
}
